import { getRowClass } from 'helpers/cell';

export const getCompanyColumns = (columnsToHide, showContactOf) =>
  [
    {
      Header: 'Name',
      accessor: 'name',
      width: '200px',
      disableSortBy: true,
      rowGroup: true,
      hide: true,
      pinned: 'left',
      cellRenderer: 'companyNameRenderer',
      suppressMovable: true,
    },
    {
      Header: 'Contact name',
      accessor: 'contactName',
      width: '320px',
      disableSortBy: true,
      disablePadding: true,
      cellRenderer: 'contactNameRenderer',
      getRowClass,
    },
    {
      Header: 'Contact job title',
      accessor: 'jobTitle',
      width: showContactOf ? '280px' : '490px',
      disableSortBy: true,
      disablePadding: true,
      cellRenderer: 'companyRowRenderer',
      getRowClass,
    },
    ...(showContactOf
      ? [
          {
            Header: 'Contact of',
            accessor: 'contactOf',
            width: '280px',
            disableSortBy: true,
            disablePadding: true,
            cellRenderer: 'contactOfRenderer',
            getRowClass,
          },
        ]
      : []),
    {
      Header: 'Can you help?',
      accessor: 'offerIntro',
      width: '260px',
      suppressMovable: true,
      resizable: false,
      disableSortBy: true,
      disablePadding: true,
      pinned: 'right',
      cellRenderer: 'introOfferRenderer',
      tooltipValueGetter: () => 'intro offer tooltip',
    },
  ].filter((column) => !columnsToHide.has(column.accessor));
